import getTypesDropdown from "./getTypesDropdown";
import getCategoriesDropdown from "./getCategoriesDropdown";
import getObservsersByProgramDropdown from "./getObservsersByProgramDropdown";
import getSpeciesDropdown from "./getSpeciesDropdown";
import getObjectsDropdown from "./getObjectsDropdown";
import getTagsDropdown from "./getTagsDropdown";
import getChatDropdown from "./getChatDropdown";
const dropdowns = {
  getTypesDropdown,
  getObjectsDropdown,
  getCategoriesDropdown,
  getSpeciesDropdown,
  getObservsersByProgramDropdown,
  getTagsDropdown,
  getChatDropdown
};

export default dropdowns;
